import i18n from 'i18next';

const role = sessionStorage.getItem('role') || localStorage.getItem('role');

const filtersMeta = [
  {
    name: 'Name',
    displayName: i18n.t('ReportList:Name'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 6,
  },

  {
    name: 'modality',
    displayName: i18n.t('ReportList:Modality'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 10,

  },
  {
    name: 'Age',
    displayName: i18n.t('ReportList:Age'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 5,

  },

  {
    name: 'Gender',
    displayName: i18n.t('ReportList:Gender'),
    inputType: 'MultiSelect',
    inputProps: {
      options: [
        { value: "Male", label: "M" },
        { value: "Female", label: "F" },
        { value: "Other", label: "O" }
      ],
    },
    isSortable: true,
    gridCol: 5,

  },
  {
    name: 'Date',
    displayName: i18n.t('ReportList:Date'),
    inputType: 'DateRange',
    isSortable: true,
    gridCol: 5,

  },
  // {
  //   name: 'Time',
  //   displayName: i18n.t('ReportList:Time'),
  //   // inputType: 'Text',
  //   isSortable: true,
  //   gridCol: 5,

  // },
  {
    name: 'PatientId',
    displayName: i18n.t('ReportList:Patient Id'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 6,

  },
  {
    name: 'UHID',
    displayName: i18n.t('ReportList:UHID'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 5,

  },

  {
    name: 'Staus',
    displayName: i18n.t('ReportList:Status'),
    inputType: 'MultiSelect',
    inputProps: {
      options: [
        { value: "Draft", label: "Drafted" },
        { value: "Completed", label: "Completed" },
        { value: "Authorized", label: "Authorized" },
        { value: "Sent", label: "Sent" },
        { value: "Delivered", label: "Delivered" },
      ],
    },
    isSortable: true,
    gridCol: 5,

  },
  {
    name: 'Action',
    displayName: i18n.t('ReportList:Action'),
    inputType: 'None',
    isSortable: false,
    gridCol: 4,

  },


];

export default filtersMeta;

const reportColumns = [
  {
    name: 'Name',
    selector: row => row?.name || '',
    sortable: true,
  },
  {
    name: 'Modality',
    selector: row => row?.modality || '',
    sortable: true,
  },
  {
    name: 'Age',
    selector: row => row?.age || '',
    sortable: true,
  },
  {
    name: 'Gender',
    selector: row => row?.gender || '',
    sortable: true,
  },
  {
    name: 'Date',
    selector: row => row?.date || '',
    sortable: true,
  },
  {
    name: 'Time',
    selector: row => row?.time || '',
    sortable: true,
  },
  {
    name: 'PatientID',
    selector: row => row?.patientId || '',
    sortable: true,
  },
  {
    name: 'UHID',
    selector: row => row?.uhid || '',
    sortable: true,
  },
  {
    name: 'Status',
    selector: row => row?.status || '',
    sortable: true,
  },

];

// const studyColumns = [
//   {
//     name: 'Date',
//     selector: row => row?.createdOn,
//   },
//   {
//     name: 'Study Id',
//     selector: row => row?._id || '',
//   },
//   {
//     name: 'Referring Doctor',
//     selector: row => row?.readingDoctorName || 'Not Assigned',
//   },
//   {
//     name: 'Description',
//     selector: row => row?.createdOn || 'none',
//   },
// ];

// const seriesColumns = [
//   {
//     name: 'Series',
//     selector: row => row.PatientID || 'none',
//   },
//   {
//     name: 'Date',
//     selector: row => row.PatientName.Alphabetic || 'none',
//   },
//   {
//     name: 'Modality',
//     selector: row => row.Modality || 'none',
//   },
//   {
//     name: 'Description',
//     selector: row => row.SeriesNumber || 'none',
//   },
// ];

export function getGridWidthClass(gridCol) {
  const widthClasses = {
    1: 'w-1/24',
    2: 'w-2/24',
    3: 'w-3/24',
    4: 'w-4/24',
    5: 'w-5/24',
    6: 'w-6/24',
    7: 'w-7/24',
    8: 'w-8/24',
    9: 'w-9/24',
    10: 'w-10/24',
    11: 'w-11/24',
    12: 'w-12/24',
    13: 'w-13/24',
    14: 'w-14/24',
    15: 'w-15/24',
    16: 'w-16/24',
    17: 'w-17/24',
    18: 'w-18/24',
    19: 'w-19/24',
    20: 'w-20/24',
    21: 'w-21/24',
    22: 'w-22/24',
    23: 'w-23/24',
    24: 'w-24/24',
  };

  return widthClasses[gridCol];
}

export { reportColumns };
